import React from "react";

export default function renderIcon({
  width = 33.29,
  height = 35.31,
  color = "#848484",
}) {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      className="arrow-prev2-icon"
    >
      <style>{`
        .arrow-prev2-icon circle {
          transition: fill 0.2s, fill-opacity 0.2s;
        }
        .arrow-prev2-icon:hover circle {
          fill: #7B47D2;
          fill-opacity: 1;
        }
      `}</style>
      <circle
        cx="30"
        cy="30"
        r="29.65"
        transform="matrix(-1 0 0 1 60 0)"
        fill="black"
        fill-opacity="0.4"
        stroke="white"
        stroke-width="0.7"
      />
      <path
        d="M25.2031 29.1084L32.4754 22.1806C32.5968 22.0647 32.7582 22 32.926 22C33.0938 22 33.2552 22.0647 33.3766 22.1806L33.3827 22.1887C33.4418 22.2447 33.489 22.3122 33.5212 22.3871C33.5534 22.4619 33.57 22.5425 33.57 22.624C33.57 22.7055 33.5534 22.7861 33.5212 22.861C33.489 22.9358 33.4418 23.0033 33.3827 23.0593L26.5364 29.5834L33.3827 36.1035C33.4418 36.1595 33.489 36.227 33.5212 36.3018C33.5534 36.3766 33.57 36.4573 33.57 36.5387C33.57 36.6202 33.5534 36.7008 33.5212 36.7757C33.489 36.8505 33.4418 36.918 33.3827 36.974L33.3766 36.9822C33.2552 37.0981 33.0938 37.1628 32.926 37.1628C32.7582 37.1628 32.5968 37.0981 32.4754 36.9822L25.2031 30.0544C25.1389 29.9934 25.0878 29.9201 25.0529 29.8388C25.018 29.7574 25 29.6699 25 29.5814C25 29.4929 25.018 29.4053 25.0529 29.324C25.0878 29.2427 25.1389 29.1693 25.2031 29.1084Z"
        fill="white"
      />
    </svg>
  );
}
